import * as React from 'react';
import { useDispatch } from 'react-redux'
import { setOperation } from '../operation/operationSlice';
import DataList from '../../components/controls/datagrid/DataList';
import DataColumn from '../../components/controls/datagrid/DataColumn';

export default (props: { controller: string, items: any }) => {
    const dispatch = useDispatch()
    const onRowClick = (e: any, data: any) => {
        e.preventDefault()
        dispatch(setOperation("read", props.controller, { index: data }))
    }

    //React.useEffect(() => {
    //    if (props?.items?.length === 1) {
    //        dispatch(setOperation("read", props.controller, { index: 0 }))
    //    }
    //}, [props?.items])

    return (
        <>
            <DataList items={props.items} onRowClick={onRowClick} >
                <DataColumn kid='column1' name='Assistito' fieldName='description' align='left' minWidth={100} />
            </DataList>
        </>
    );
}
